export default __webpack_public_path__ + "static/amex-banner-c67f49151b8319fe68817ccb11a67f0c.jpg";